import React from "react";
import SyncedAt from "../../admin/projects/syncedAt";

const ProjectInfo = ({ project }) => {

  return (
      <p className='text-xs'>
        <SyncedAt project={project} />
      </p>
  )
}

export default ProjectInfo
